export default __webpack_public_path__ + "static/media/Concept2.c5b03ab3.png";